;(function () {
    function CartConfigurationController() {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            if (!window.Creaton.Cart) {
                window.Creaton.Cart = {}
                _this.setConfig()
            }
        }

        this.refreshConfig = function () {
            window.Creaton.Cart.Configuration.$cartModalCta = $('[rel="add-to-card-cta"]')
        }

        this.setConfig = function () {
            window.Creaton.Cart.Configuration = {
                /**
                 * relation to html button to show cart modal
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $cartModalCta: $('[rel="add-to-card-cta"]'),

                /**
                 * relation to html body of modal
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $modalBody: $('[rel="cart-modal-body"]'),

                /**
                 * relation to html modal
                 * https://getbootstrap.com/docs/4.0/components/modal/
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $cartModal: $('[rel="cart-modal"]'),

                /**
                 * relation to html cart header icon
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $cartHeaderIcon: $('[rel="cart-header-icon"]'),

                /**
                 * relation to html update header icon counter
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $cartHeaderIconCounter: $('[data-cart-header-icon-counter="true"]'),

                /**
                 * relation to html cart modal header
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $modalHeader: $('[rel="cart-modal-header"]'),

                /**
                 * relation to html header sample counter
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $sampleOrderWarning: $('[rel="sample-order-warning"]'),

                /**
                 * relation to html sample order submit
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $sampleOrderSubmit: $('[rel="sample-order-submit"]'),

                /**
                 * relation to html sample order form
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $sampleOrderForm: $('[rel="sample-order-form"]'),

                /**
                 * relation to html sample order empty cart message
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                $sampleOrderEmptyCartMessage: $('[rel="sample-order-empty-cart"]'),

                /**
                 * sample order form identifier
                 * @type {string}
                 */
                sampleOrderForm: '[rel="sample-order-form"]',

                /**
                 * sample order overview identifier
                 * @type {string}
                 */
                sampleOrderOverview: '[rel="sample-order-samples-list"]',

                /**
                 * sample item order code
                 * @type {string}
                 */
                sampleOrderItemOrderCode: 'data-sample-item-order-code',

                /**
                 * sample order select data with order code
                 * @type {string}
                 */
                sampleOrderOrderCode: 'data-sample-order-code',

                /**
                 * sample order input field with sample data
                 * @type {string}
                 */
                sampleOrderInputSampleData: 'data-sample-input-sample-data',

                /**
                 * relation to html remove sample icon
                 * @type {jQuery.fn.init|jQuery|HTMLElement}
                 */
                removeSampleItem: '[rel="sample-order-item-remove"]',

                /**
                 * cart Item identifier
                 * https://getbootstrap.com/docs/4.0/components/modal/
                 * @type {string}
                 */
                cartItem: '[rel="cart-item"]',

                /**
                 * name of the storage identifier
                 * @type {string}
                 */
                cart: 'creatonSampleOrderCart',

                /**
                 * name of the storage identifier for last payment hash over cart
                 * @type {string}
                 */
                lastPayment: 'creatonLastPaymentSampleOrder',

                /**
                 * html cart template identifier
                 * @type {string}
                 */
                templateContainer: '[rel="cart-modal-item-template"]',

                /**
                 * html sample order samples template identifier
                 * @type {string}
                 */
                sampleOrderTemplateContainer: '[rel="sample-order-samples-template"]',
                /**
                 * update local storage listener identifier
                 * @type {string}
                 */
                cartEventListener: 'updateCreatonCart',

                /**
                 * contains items from local storage
                 * @type {object}
                 */
                cartItems: {},

                /**
                 * total amount of samples
                 * @type {int}
                 */
                totalAmountOfSamples: 0,

                /**
                 * max amount of sample for order
                 * CAUTION: take care this is the same amount like the server side validation configuration(Settings.yaml: Creaton.Product.sampleOrder.maxAmountTiles)
                 * @type {int}
                 */
                maxSampleAmount: 3,

                /**
                 * name of model property of sample data identifier
                 * @type {string}
                 */
                sampleDataIdentifier: 'sampleData',

                /**
                 * sample order select rel identifier
                 * @type {string}
                 */
                sampleOrderSelectIdentifier: 'sample-order-item-select',
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Creaton = window.Creaton || {}

    window.Creaton.CartConfigurationController = CartConfigurationController
})()

$(document).ready(function () {
    window.Creaton.cartConfigurationCtrl = new window.Creaton.CartConfigurationController()
})
